import React, { Component } from 'react'

// ui
import Modal from '../../components/feedback/modal'
import Button from '../../components/uielements/button'
import {
    Form, Input, Switch, Upload, InputNumber, Row, Col, Menu,
    Dropdown,
} from 'antd'
import { Spin } from 'antd'
import { FaCheck, FaTimes, FaPlus, FaSave, FaEdit } from 'react-icons/fa'

// redux
import { connect } from 'react-redux'
import objectActions from '../../redux/component_select_object/actions'

const { TextArea } = Input

// function helper
function getBase64(img, callback) {
    const reader = new FileReader()
    reader.addEventListener('load', () => callback(reader.result))
    reader.readAsDataURL(img)
}

class ObjectInfoForm extends Component {
    state = {
        confirmDirty: false,
        loading: false,
        imageUrl: null,
        countId: 0,
        countExtend: 0,
        extendIndex: [],
        extendKey: [],
        extendData: [],
        extendKeyErr: [],
        extendDataErr: [],
        isEdit: [],
        suggestion: false,
    }

    // validator

    // handle
    handleChange = info => {
        if (info.file.status === 'uploading') {
            this.setState({ loading: true, imageUrl: null })
            return
        }
        if (info.file.status === 'done') {
            this.props.updateAvatar(info.file.originFileObj)

            // Get this url from response in real world.
            getBase64(info.file.originFileObj, imageUrl => {
                this.setState({
                    imageUrl,
                    loading: false,
                })
            })
        }
    }

    // helper
    equalArray = (arr1, arr2) => {
        if (!Array.isArray(arr1) || !Array.isArray(arr2)) return false
        if (arr1.length !== arr2.length) return false
        for (let index = 0; index < arr1.length; index++)
            if (arr1[index] !== arr2[index]) return false

        return true
    }

    isInArray(value, array) {
        return array.indexOf(value) > -1
    }

    // update new props
    componentWillReceiveProps(nextProps) {
        let isUpdateNew = false
        if (nextProps.object !== this.props.object) {
            const { form, object } = nextProps
            if (object && object.hashtag) {
                console.log('object data', object)
                form.setFieldsValue({ name: object.name })
                form.setFieldsValue({ desc: object.desc })
                if (object.age) {
                    form.setFieldsValue({ age: object.age.toString() })
                } else {
                    form.setFieldsValue({ age: '' })

                }
                form.setFieldsValue({ email: object.email })
                form.setFieldsValue({ home_town: object.home_town })
                form.setFieldsValue({ link_fb: object.link_fb })
                form.setFieldsValue({ link_insta: object.link_insta })
                form.setFieldsValue({ phone: object.phone })
                form.setFieldsValue({ work: object.work })
                form.setFieldsValue({ education: object.education })

                let imageUrl = this.state.imageUrl
                if (object.avatar !== null) imageUrl = object.avatar

                this.setState({
                    imageUrl: imageUrl,
                    countId: object.hashtag.length,
                })


                if (object.ext_data && object.ext_data.lstExtendData) {
                    const lstExtendData = JSON.parse(object.ext_data.lstExtendData)
                    let lstIndex = []
                    let ExtendKey = []
                    let ExtendData = []
                    let ExtendKeyerr = []
                    let ExtendDataerr = []
                    let lstIsEdit = []
                    lstExtendData.map((extData, index) => {
                        lstIndex.push(index)
                        ExtendKey.push(extData.label)
                        ExtendData.push(extData.data)
                        ExtendKeyerr.push(true)
                        ExtendDataerr.push(true)
                        lstIsEdit.push(false)
                    })

                    this.setState({
                        extendIndex: lstIndex,
                        countExtend: lstExtendData.length,
                        extendData: ExtendData,
                        extendKey: ExtendKey,
                        extendKeyErr: ExtendKeyerr,
                        extendDataErr: ExtendDataerr,
                        isEdit: lstIsEdit,
                    })
                } else {
                    this.setState({
                        extendIndex: [],
                        countExtend: 0,
                        extendData: [],
                        extendKey: [],
                        extendKeyErr: [],
                        extendDataErr: [],
                        isEdit: [],
                    })
                }

                form.setFieldsValue({
                    tags: [],
                    names: [],
                })

                const tags = object.hashtag
                for (let index = 0; index < tags.length; index++) {
                    const keys = form.getFieldValue('tags')
                    const nextKeys = keys.concat(index)
                    form.setFieldsValue({
                        tags: nextKeys,
                    })
                }
                form.setFieldsValue({
                    names: tags,
                })

            }
        }
    }

    componentDidMount() {
        const { form, object } = this.props
        if (object && object.hashtag) {
            form.setFieldsValue({ name: object.name })
            form.setFieldsValue({ desc: object.desc })
            if (object.age) {
                form.setFieldsValue({ age: object.age.toString() })
            }
            form.setFieldsValue({ email: object.email })
            form.setFieldsValue({ home_town: object.home_town })
            form.setFieldsValue({ link_fb: object.link_fb })
            form.setFieldsValue({ link_insta: object.link_insta })
            form.setFieldsValue({ phone: object.phone })
            form.setFieldsValue({ work: object.work })
            form.setFieldsValue({ education: object.education })

            this.setState({
                imageUrl: object.avatar,
                countId: object.hashtag.length,
            })
            if (object.ext_data && object.ext_data.lstExtendData) {
                const lstExtendData = JSON.parse(object.ext_data.lstExtendData)
                let lstIndex = []
                let ExtendKey = []
                let ExtendData = []
                let ExtendKeyerr = []
                let ExtendDataerr = []
                let lstIsEdit = []
                lstExtendData.map((extData, index) => {
                    lstIndex.push(index)
                    ExtendKey.push(extData.label)
                    ExtendData.push(extData.data)
                    ExtendKeyerr.push(true)
                    ExtendDataerr.push(true)
                    lstIsEdit.push(false)
                })

                this.setState({
                    extendIndex: lstIndex,
                    countExtend: lstExtendData.length,
                    extendData: ExtendData,
                    extendKey: ExtendKey,
                    extendKeyErr: ExtendKeyerr,
                    extendDataErr: ExtendDataerr,
                    isEdit: lstIsEdit,
                })
            }

            form.setFieldsValue({
                tags: [],
                names: [],
            })

            const tags = object.hashtag
            for (let index = 0; index < tags.length; index++) {
                const keys = form.getFieldValue('tags')
                const nextKeys = keys.concat(index)
                form.setFieldsValue({
                    tags: nextKeys,
                })
            }

            console.log('Start')
            form.setFieldsValue({
                names: tags,
            })
            console.log('End')
        }
    }

    // event
    onSubmit = e => {
        e.preventDefault()
        this.props.form.validateFields((err, values) => {
            if (!err) {
                const lstExtData = []
                let error = true
                this.state.extendIndex.map(index => {
                    if (this.state.extendKey[index].trim() === '') {
                        error = false
                        let errkey = this.state.extendKeyErr
                        errkey[index] = false
                        this.setState({ extendKeyErr: errkey })
                    }
                    if (this.state.extendData[index].trim() === '') {
                        error = false
                        let errData = this.state.extendDataErr
                        errData[index] = false
                        this.setState({ extendKeyErr: errData })
                    }
                    const newData = {
                        label: this.state.extendKey[index],
                        data: this.state.extendData[index],
                    }
                    lstExtData.push(newData)
                })

                if (error) {
                    this.props.dismiss()

                    this._handleUpdateCurrentTag()
                    this.props.saveCurrentObject(lstExtData)
                }
            }
        })
    }

    // handle
    _handleUpdateCurrentTag = () => {
        try {
            const { form } = this.props
            const names = form.getFieldValue('names')
            const keys = form.getFieldValue('tags')

            if (names.length < keys.length) return

            const nextNames = names.filter((tag, index) => {
                if (!this.isInArray(index, keys)) {
                    return false
                }
                if (typeof tag === undefined) return false
                if (tag === '') return false
                return true
            })

            if (this.equalArray(this.props.object.hashtag, nextNames) === false)
                this.props.updateCurrentObject({ hashtag: nextNames })
        } catch { }
    }

    _handleAddTag = () => {
        const { form } = this.props
        const keys = form.getFieldValue('tags')
        const names = form.getFieldValue('names')

        // Kiểm tra tag trên cùng có phải rỗng k
        console.log('Keys : ', keys)
        if (keys.length > 0 && names[keys.length - 1].trim() === '') return

        const nextKeys = keys.concat(this.state.countId)
        form.setFieldsValue({
            tags: nextKeys,
        })

        this.setState({ countId: this.state.countId + 1 })
    }
    _handleAddExtendData = () => {
        const crrIndex = this.state.extendIndex.concat(this.state.countExtend)
        const crrKey = this.state.extendKey.concat('')
        const crrData = this.state.extendData.concat('')
        const crrDataErr = this.state.extendDataErr.concat(true)
        const crrKeyErr = this.state.extendKeyErr.concat(true)
        const isEdit = this.state.isEdit.concat(true)

        this.setState({
            extendIndex: crrIndex,
            countExtend: this.state.countExtend + 1,
            extendKey: crrKey,
            extendData: crrData,
            extendDataErr: crrDataErr,
            extendKeyErr: crrKeyErr,
            isEdit: isEdit,
        })
    }
    _handleDeleteIExtData = (index) => {

        const crrKey = this.state.extendKey
        crrKey.splice(index, 1)

        const crrData = this.state.extendData
        crrData.splice(index, 1)

        const crrDataErr = this.state.extendDataErr
        crrDataErr.splice(index, 1)

        const crrKeyErr = this.state.extendKeyErr
        crrKeyErr.splice(index, 1)

        const isEdit = this.state.isEdit
        isEdit.splice(index, 1)
        const crrIndex = []
        crrKey.map((vl, index) => {
            crrIndex.push(index)
        })


        this.setState({
            extendIndex: crrIndex,
            countExtend: this.state.countExtend - 1,
            extendKey: crrKey,
            extendData: crrData,
            extendDataErr: crrDataErr,
            extendKeyErr: crrKeyErr,
            isEdit: isEdit,
        })
    }

    _handleDelete = id => {
        const { form } = this.props
        console.log('id delete', id)
        const keys = form.getFieldValue('tags')
        const namesData = form.getFieldValue('names')
        const nextName = namesData.filter((item, index) => {
            return index != id
        })
        const nextKeys = keys.filter(key => key !== id)
        form.setFieldsValue({
            tags: nextKeys,
        })
        this.props.updateCurrentObject({ hashtag: nextName })
    }

    render() {
        const { getFieldDecorator, getFieldValue } = this.props.form

        const formItemLayout = {
            labelCol: {
                xs: { span: 24 },
                sm: { span: 8 },
            },
            wrapperCol: {
                xs: { span: 24 },
                sm: { span: 16 },
            },
        }
        const formItemLayoutWithOutLabel = {
            wrapperCol: {
                xs: { span: 24, offset: 24 },
                sm: { span: 16, offset: 8 },
            },
        }

        const { imageUrl } = this.state

        const formExtendData = Array.isArray(this.state.extendIndex)
            ? this.state.extendIndex.map((value, index) => (
                <div style={{ padding: 10 }}>
                    <Row>
                        <Col
                            style={{
                                display: 'flex',
                                justifyContent: 'flex-end',
                            }}
                            span={8}
                        >
                            {' '}
                            {this.state.isEdit[index] && (
                                <div
                                    style={{
                                        display: 'flex',
                                        flexDirection: 'column',
                                    }}
                                >
                                    <Input
                                        style={{
                                            width: 200,
                                            marginRight: 15,
                                            alignItems: 'center',
                                        }}
                                        onChange={value => {
                                            let datakey = this.state.extendKey
                                            datakey[index] =
                                                value.target.value
                                            this.setState({
                                                extendKey: datakey,
                                            })

                                        }}
                                        onBlur={() => {
                                            const lstExtData = []
                                            let error = true
                                            this.state.extendIndex.map(index => {
                                                if (this.state.extendKey[index].trim() === '') {
                                                    error = false
                                                    let errkey = this.state.extendKeyErr
                                                    errkey[index] = false
                                                    this.setState({ extendKeyErr: errkey })
                                                }
                                                if (this.state.extendData[index].trim() === '') {
                                                    error = false
                                                    let errData = this.state.extendDataErr
                                                    errData[index] = false
                                                    this.setState({ extendKeyErr: errData })
                                                }
                                                const newData = {
                                                    label: this.state.extendKey[index],
                                                    data: this.state.extendData[index],
                                                }
                                                lstExtData.push(newData)

                                            })

                                            if (!error) {
                                                this.props.updateCurrentObject({ ext_data: { lstExtendData: JSON.stringify(lstExtData) } })
                                            }
                                            console.log('lstExtData', lstExtData)
                                        }}
                                        defaultValue={
                                            this.state.extendKey[index]
                                        }
                                        placeholder="Tên trường dữ liệu"
                                    />
                                    {!this.state.extendKeyErr[index] && (
                                        <text
                                            style={{
                                                color: 'red',
                                                fontSize: 15,
                                            }}
                                        >
                                            Mời nhập tên trường dữ liệu
                                        </text>
                                    )}
                                </div>
                            )}
                            {!this.state.isEdit[index] && (
                                <text
                                    style={{
                                        marginRight: 15,
                                        alignItems: 'center',
                                        paddingTop: 4,
                                    }}
                                >
                                    {this.state.extendKey[index]} :
                                </text>
                            )}
                        </Col>
                        <Col
                            span={16}
                            style={{
                                display: 'flex',
                                flexDirection: 'row',
                                alignItems: 'center',
                                justifyItems: 'center',
                            }}
                        >
                            <div
                                style={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    width: '100%',
                                }}
                            >
                                <Input
                                    placeholder="Thông tin"
                                    defaultValue={
                                        this.state.extendData[index]
                                    }
                                    value={this.state.extendData[index]}
                                    onChange={value => {
                                        let data = this.state.extendData
                                        data[index] = value.target.value
                                        this.setState({ extendData: data })
                                        const lstExtData = []
                                        let error = true
                                        this.state.extendIndex.map(index => {
                                            if (this.state.extendKey[index].trim() === '') {
                                                error = false
                                                let errkey = this.state.extendKeyErr
                                                errkey[index] = false
                                                this.setState({ extendKeyErr: errkey })
                                            }
                                            if (this.state.extendData[index].trim() === '') {
                                                error = false
                                                let errData = this.state.extendDataErr
                                                errData[index] = false
                                                this.setState({ extendKeyErr: errData })
                                            }
                                            const newData = {
                                                label: this.state.extendKey[index],
                                                data: this.state.extendData[index],
                                            }
                                            lstExtData.push(newData)
                                        })
                                        console.log('lstExtData', lstExtData)
                                        this.state.isEdit[index] = true
                                        this.props.updateCurrentObject({ ext_data: { lstExtendData: JSON.stringify(lstExtData) } })

                                    }}
                                    style={{ width: '95%' }}
                                />
                                {!this.state.extendDataErr[index] && (
                                    <text
                                        style={{ color: 'red', fontSize: 15 }}
                                    >
                                        Hãy nhập thông tin này
                                    </text>
                                )}
                            </div>
                            <FaEdit
                                size={20}
                                style={{ paddingLeft: 4, cursor: 'pointer' }}
                                onClick={() => {
                                    let isEdit = this.state.isEdit
                                    isEdit[index] = true
                                    this.setState({ isEdit: isEdit })
                                }}
                            />
                            <FaTimes
                                size={15}
                                style={{ paddingLeft: 4, cursor: 'pointer' }}
                                onClick={() => { this._handleDeleteIExtData(index) }}
                            />
                        </Col>
                    </Row>
                </div>
            ))
            : null

        getFieldDecorator(`tags`, { initialValue: [] })

        const tags = getFieldValue('tags')
        const formItems = Array.isArray(tags)
            ? tags.map((k, index) => (
                <Form.Item
                    {...(index === 0
                        ? formItemLayout
                        : formItemLayoutWithOutLabel)}
                    label={index === 0 ? 'Thẻ' : ''}
                    required={false}
                    key={k}
                >
                    {getFieldDecorator(`names[${k}]`, {
                        validateTrigger: ['onChange', 'onBlur'],
                        onChange: (vl) => {
                            const namesData = this.props.form.getFieldValue('names')
                            namesData[k] = vl.target.value
                            this.props.updateCurrentObject({ hashtag: namesData })
                        },
                        rules: [
                            {
                                required: true,
                                whitespace: true,
                                message: 'Xin mời nhập nội dung thẻ',
                            },
                        ],
                        initialValue: this.props.object.hashtag[index]
                            ? this.props.object.hashtag[index]
                            : '',
                    })(
                        <Input
                            placeholder="Tên thẻ"

                            style={{ width: '60%', marginRight: 8 }}
                        />
                    )}
                    <FaTimes onClick={() => this._handleDelete(k)} />
                </Form.Item>
            ))
            : null

        const uploadButton = (
            <div>
                {this.state.loading ? <Spin /> : <FaPlus />}
                <div className="ant-upload-text" style={{ fontSize: 13 }}>
                    Upload avatar
                </div>
            </div>
        )

        const dummyRequest = ({ file, onSuccess }) => {
            setTimeout(() => {
                onSuccess('ok')
            }, 0)
        }
        const menu = (
            <Menu>
                {this.props.suggestionData.length > 0 &&
                    this.props.suggestionData.map(data => (
                        <Menu.Item>
                            {data.name}
                        </Menu.Item>
                    ))}


            </Menu>
        )
        let namedata = getFieldValue('name')

        return (
            <Form {...formItemLayout} onSubmit={this.onSubmit}>
                <Form.Item
                    label={null}
                    extra={null}
                    style={{ marginLeft: '40%' }}
                >
                    {getFieldDecorator('upload', {})(
                        <Upload
                            name="avatar"
                            showUploadList={false}
                            listType="picture-card"
                            className="avatar-uploader"
                            onChange={this.handleChange}
                            customRequest={dummyRequest}
                            style={{ backgroundColor: 'white' }}
                        >
                            {imageUrl && imageUrl !== '' ? (
                                <img
                                    src={imageUrl}
                                    alt="avatar"
                                    style={{ width: '100%' }}
                                />
                            ) : (
                                    uploadButton
                                )}
                        </Upload>
                    )}
                </Form.Item>
                <Form.Item label="Tên đối tượng" hasFeedback>
                    {getFieldDecorator('name', {
                        rules: [
                            {
                                required: true,
                                message: 'Xin mời nhập tên đối tượng',
                                whitespace: true,
                            },
                        ],
                    })(
                        <Dropdown
                            overlay={menu}
                            placement="bottomLeft"
                            visible={this.state.suggestion}
                        >
                            <Input
                                autoComplete="off"
                                onBlur={() => {
                                    this.setState({ suggestion: false })
                                }}
                                value={namedata}
                                onChange={value => {
                                    this.props.updateCurrentObject({
                                        name: value.target.value,
                                    })
                                    if (value.target.value === '') {
                                        this.setState({ suggestion: false })
                                        this.props.getSuggestionDone([])
                                    } else {
                                        this.props.getSuggestion(value.target.value)
                                        this.setState({ suggestion: true })
                                    }
                                }}
                            />
                        </Dropdown>
                    )}
                </Form.Item>

                <Form.Item label="Năm sinh" hasFeedback>
                    {getFieldDecorator('age', {
                        rules: [
                            {
                                whitespace: true,
                            },
                        ],
                    })(
                        <InputNumber
                            onChange={value => {
                                this.props.updateCurrentObject({
                                    age: value,
                                })
                            }}
                        />
                    )}
                </Form.Item>
                <Form.Item label="Công việc hiện tại" hasFeedback>
                    {getFieldDecorator('work', {
                        rules: [
                            {
                                message: 'Xin mời nhập công việc của đối tượng',
                                whitespace: true,
                            },
                        ],
                    })(
                        <Input
                            onChange={value => {
                                this.props.updateCurrentObject({
                                    work: value.target.value,
                                })
                            }}
                        />
                    )}
                </Form.Item>
                <Form.Item label="Quê quán" hasFeedback>
                    {getFieldDecorator('home_town', {
                        rules: [
                            {
                                message: 'Xin mời nhập quê quán của đối tượng',
                                whitespace: true,
                            },
                        ],
                    })(
                        <Input
                            onChange={value => {
                                this.props.updateCurrentObject({
                                    home_town: value.target.value,
                                })
                            }}
                        />
                    )}
                </Form.Item>
                <Form.Item label="Link Facebook" hasFeedback>
                    {getFieldDecorator('link_fb', {
                        rules: [
                            {
                                message: 'Xin mời nhập link facebook',
                                whitespace: true,
                            },
                        ],
                    })(
                        <Input
                            onChange={value => {
                                this.props.updateCurrentObject({
                                    link_fb: value.target.value,
                                })
                            }}
                        />
                    )}
                </Form.Item>
                <Form.Item label="Link Instagram" hasFeedback>
                    {getFieldDecorator('link_insta', {
                        rules: [
                            {
                                message:
                                    'Xin mời nhập link instagram của đối tượng',
                                whitespace: true,
                            },
                        ],
                    })(
                        <Input
                            onChange={value => {
                                this.props.updateCurrentObject({
                                    link_insta: value.target.value,
                                })
                            }}
                        />
                    )}
                </Form.Item>
                <Form.Item label="Số điện thoại" hasFeedback>
                    {getFieldDecorator('phone', {
                        rules: [
                            {
                                message:
                                    'Xin mời nhập số điện thoại của đối tượng',
                                whitespace: true,
                            },
                        ],
                    })(
                        <Input
                            onChange={value => {
                                this.props.updateCurrentObject({
                                    phone: value.target.value,
                                })
                            }}
                        />
                    )}
                </Form.Item>
                <Form.Item label="Email" hasFeedback>
                    {getFieldDecorator('email', {
                        rules: [
                            {
                                message: 'Xin mời nhập email của đối tượng',
                                whitespace: true,
                            },
                        ],
                    })(
                        <Input
                            onChange={value => {
                                this.props.updateCurrentObject({
                                    email: value.target.value,
                                })
                            }}
                        />
                    )}
                </Form.Item>
                <Form.Item label="Trình độ học vấn" hasFeedback>
                    {getFieldDecorator('education', {
                        rules: [
                            {
                                message:
                                    'Xin mời nhập trình độ học vấn của đối tượng',
                                whitespace: true,
                            },
                        ],
                    })(
                        <Input
                            onChange={value => {
                                this.props.updateCurrentObject({
                                    education: value.target.value,
                                })
                            }}
                        />
                    )}
                </Form.Item>
                <Form.Item label="Mô tả đối tượng" hasFeedback>
                    {getFieldDecorator('desc', {
                        rules: [
                            {
                                required: true,
                                message: 'Xin mời nhập mô tả đối tượng',
                                whitespace: true,
                            },
                        ],
                    })(
                        <TextArea
                            rows={3}
                            autosize={{ minRows: 3, maxRows: 3 }}
                            onChange={value =>
                                this.props.updateCurrentObject({
                                    desc: value.target.value,
                                })
                            }
                        />
                    )}
                </Form.Item>
                {formItems}
                {formExtendData}
                <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'center' }}>
                    <Form.Item {...formItemLayoutWithOutLabel}>
                        <Button
                            onClick={() => this._handleAddTag()}
                            style={{
                                border: '1px solid blue',
                                color: 'blue',
                                marginBottom: 20,
                            }}
                        >
                            <FaPlus style={{ marginRight: 5 }} /> Thêm thẻ
                    </Button>
                    </Form.Item>
                    <Form.Item {...formItemLayoutWithOutLabel}>
                        <Button
                            onClick={() => this._handleAddExtendData()}
                            style={{
                                border: '1px solid blue',
                                color: 'blue',
                                marginBottom: 20,
                            }}
                        >
                            <FaPlus style={{ marginRight: 5 }} /> Thêm trường dữ
                        liệu
                    </Button>
                    </Form.Item>
                </div>
                <Form.Item wrapperCol={{ span: 15, offset: 11 }}>
                    <Button
                        size="large"
                        htmlType="submit"
                        style={{
                            backgroundColor: 'lightgreen',
                            marginRight: 5,
                            color: 'black',
                        }}
                    >
                        <FaSave style={{ marginRight: 5 }} />
                        Lưu
                    </Button>

                    <Button
                        size="large"
                        onClick={() => this.props.onCancel()}
                        style={{ backgroundColor: ' #ffcccc', color: 'black' }}
                    >
                        <FaTimes style={{ marginRight: 5 }} />
                        Huỷ
                    </Button>
                </Form.Item>
            </Form>
        )
    }
}

const _mapStateToFormProps = state => {
    return {
        object: state.component_select_object.currentObject,
        suggestionData: state.component_select_object.suggestionData,

    }
}

const _mapDispatchToFormProps = dispatch => {
    return {
        updateCurrentObject: object => {
            dispatch(objectActions.action.updateCurrentObject(object))
        },
        updateAvatar: avatar => {
            dispatch(objectActions.action.updateAvatar(avatar))
        },
        saveCurrentObject: extendData => {
            dispatch(objectActions.action.saveCurrentObject(extendData))
        },
        dismiss: () => {
            dispatch(objectActions.action.dismissModalCurrentObjectInfo())
        },
        getSuggestion: (text) => {
            dispatch(objectActions.action.getSuggestionData(text))
        },
        getSuggestionDone: (data) => {
            dispatch(objectActions.action.getSuggestionDataDone(data))
        }
    }
}

const WrappedRegistrationForm = Form.create({ name: 'objectInfo' })(
    ObjectInfoForm
)
const ObjectForm = connect(
    _mapStateToFormProps,
    _mapDispatchToFormProps
)(WrappedRegistrationForm)

class ModalObjectInfo extends Component {
    _handleOK = () => {
        this.props.dismiss()
    }

    _handleCancel = () => {
        this.props.dismiss()
    }

    render() {
        const { visible } = this.props
        return (
            <Modal
                visible={visible}
                title="Chi tiết đối tượng"
                onOk={() => this._handleOK()}
                onCancel={() => this._handleCancel()}
                width={800}
                centered
                footer={null}
            >
                <ObjectForm
                    onOk={() => this._handleOK()}
                    onCancel={() => this._handleCancel()}
                />
            </Modal>
        )
    }
}

const mapStatetToProps = state => {
    return {
        visible: state.component_select_object.modalInfoObjectState,
    }
}

const mapDipatchToProps = dispatch => {
    return {
        dismiss: () => {
            dispatch(objectActions.action.dismissModalCurrentObjectInfo())
        },
    }
}

export default connect(
    mapStatetToProps,
    mapDipatchToProps
)(ModalObjectInfo)
